import IModel from "./IModel";
import { resolveAssetUrl } from "../utils/assetUrl";

export enum UserRole {
	Admin = 1,
	Partner = 2,
	User = 3,
}

export const UserRoleList = [UserRole.Admin, UserRole.Partner, UserRole.User];

export const UserRoleLabelMap = new Map([
	[UserRole.Admin, "Admin"],
	[UserRole.Partner, "Partner"],
	[UserRole.User, "User"],
]);

export const UserRoleLabelVNMap = new Map([
	[UserRole.Admin, "Admin"],
	[UserRole.Partner, "Cơ sở"],
	[UserRole.User, "Khách hàng"],
]);

export enum UserStatus {
	Pending = 1,
	Active = 2,
	Disabled = 3,
	Waiting = 4,
}

export enum UserVerifyStatus {
	Normal = 1,
	Verified = 2,
}

export enum UserVerifyLevel {
	Unset = 1,
	Bronze = 2,
	Silver = 3,
	Gold = 4,
	Diamond = 5,
}

export enum PaymentList {
	PayPalCard = 1,
	PayPalNomal = 2,
	ApplePay = 3,
	GGPay = 4,
	OnePay = 5,
	SSPay = 6,
	Stripe = 7,
	ApplePayPal = 8,
	GGPayPal = 9,
	ApplePayStripe = 10,
	GGPayStripe = 11,
}
export const PaymentLabelMap = new Map([
	[PaymentList.PayPalCard, "PayPalCard"],
	[PaymentList.PayPalNomal, "PayPalNomal"],
	[PaymentList.ApplePay, "ApplePay"],
	[PaymentList.GGPay, "GGPay"],
	[PaymentList.OnePay, "OnePay"],
	[PaymentList.SSPay, "SSPay"],
	[PaymentList.Stripe, "Stripe"],
	[PaymentList.SSPay, "ApplePayPal"],
	[PaymentList.Stripe, "GGPayPal"],
	[PaymentList.ApplePayStripe, "ApplePayStripe"],
	[PaymentList.GGPayStripe, "GGPayStripe"],
]);

export enum PaymentMethodList {
	PayPalCard = "PayPal Card",
	PayPalNomal = "PayPal Nomal",
	ApplePay = "OnePay Apple Pay",
	GGPay = "OnePay Google Pay",
	OnePay = "OnePay Normal",
	SSPay = "OnePay Samsung Pay",
	Stripe = "Stripe",
	GGPayStripe = "Stripe Google Pay",
	ApplePayStripe = "Stripe Apple Pay",
}

export interface IUser {
	id: string | null;
	role: number | null;
	token: string | null;
	refreshToken: string | null;
}

export default class User implements IUser, IModel<User> {
	id: string | null;
	name: string | null;
	role: number | null;
	token: string | null;
	refreshToken: string | null;
	fullName?: string | null;
	phone?: string | null;
	email?: string | null;
	gender?: number;
	avatar?: string | null;
	address?: string | null;
	partnerId?: number | null;
	communicationId?: string | null;
	lat?: number | null;
	long?: number | null;
	coordinate?: string | null;
	createdAt?: Date | null;
	updatedAt?: Date | null;
	expireTime: Date | null;
	userId?: string | null;
	accessToken?: string | string;
	status?: number | null;
	phonePrefix?: string | null;
	displayName?: string | null;
	displayAddress?: string | null;
	active?: boolean;
	isBanned?: boolean;
	banReason?: string | null;
	bannedAt?: Date | string | null;
	bannedBy?: number | null;
	urlImage?: string | null;
	workTime?: WorkTime[] | null;
	/** True when the admin user has the super_admin flag (audit timeline access). */
	isSuperAdmin?: boolean;

	constructor(input?: Partial<User>) {
		this.id = input?.id || null;
		this.name = input?.name || null;
		this.fullName = input?.fullName;
		this.phone = input?.phone;
		this.email = input?.email;
		this.role = input?.role || null;
		this.gender = input?.gender;
		this.avatar = resolveAssetUrl(input?.avatar);
		this.token = input?.token || null;
		this.refreshToken = input?.refreshToken || null;
		this.address = input?.address;
		this.partnerId = input?.partnerId;
		this.communicationId = input?.communicationId;
		this.lat = input?.lat;
		this.long = input?.long;
		this.coordinate = input?.coordinate;
		this.userId = input?.userId;

		this.createdAt = input?.createdAt;
		this.updatedAt = input?.updatedAt;
		this.expireTime = input?.expireTime || null;
		this.accessToken = input?.accessToken;
		this.status = input?.status;
		this.phonePrefix = input?.phonePrefix;
		this.displayName = input?.displayName;
		this.displayAddress = input?.displayAddress;
		this.active = input?.active;
		this.isBanned = input?.isBanned;
		this.banReason = input?.banReason;
		this.bannedAt = input?.bannedAt;
		this.bannedBy = input?.bannedBy;
		this.urlImage = resolveAssetUrl(input?.urlImage);
		this.workTime = input?.workTime;

		// this.createUserName();
	}

	parse(json: any): User {
		if (!json) return this;
		Object.assign(this, {
			...json,
			avatar: resolveAssetUrl(json.avatar),
			urlImage: resolveAssetUrl(json.urlImage),
			createdAt: json.createdAt && new Date(json.createdAt),
			bannedAt: json.bannedAt && new Date(json.bannedAt),
			expireTime: json.expiredIn && new Date(json.expiredIn),
			expiredIn: json.expiredIn,
		});

		// this.createUserName();

		return this;
	}
	parseList(jsons: any) {
		if (!jsons || !jsons.length) return;

		return jsons.map((item: any) => new User().parse(item));
	}

	createUserName() {
		// this.userName = [this.firstName, this.lastName].filter((val) => val).join(" ");
	}

	clone(): User {
		return new User({
			...this,
		});
	}
}

export class WorkTime implements IModel<WorkTime> {
	date?: WorkTimeInner | null;
	hour?: WorkTimeInner | null;

	constructor(input?: Partial<WorkTime>) {
		this.date = input?.date ?? null;
		this.hour = input?.hour ?? null;
	}

	parse(json: any): WorkTime {
		if (!json) return this;
		Object.assign(this, {
			...json,
		});

		return this;
	}

	clone(): WorkTime {
		return new WorkTime({
			...this,
		});
	}
}

export class WorkTimeInner implements IModel<WorkTimeInner> {
	to?: string | null;
	from?: string | null;

	constructor(input?: Partial<WorkTimeInner>) {
		this.to = input?.to ?? null;
		this.from = input?.from ?? null;
	}

	parse(json: any): WorkTimeInner {
		if (!json) return this;
		Object.assign(this, {
			...json,
		});

		return this;
	}

	clone(): WorkTimeInner {
		return new WorkTimeInner({
			...this,
		});
	}
}

export class PaymentMethod implements IModel<PaymentMethod> {
	id: number;
	name?: string | null;
	status?: number | null;
	type?: number | null;
	subType?: number | null;
	orderIndex?: number | null;
	createdAt?: Date | null;
	updatedAt?: Date | null;

	constructor(input?: Partial<PaymentMethod>) {
		this.id = input?.id || 0;
		this.name = input?.name ?? null;
		this.status = input?.status ?? null;
		this.type = input?.type ?? null;
		this.subType = input?.subType ?? null;
		this.orderIndex = input?.orderIndex ?? null;
		this.createdAt = input?.createdAt ?? null;
		this.updatedAt = input?.updatedAt ?? null;
	}

	parse(json: any): PaymentMethod {
		if (!json) return this;
		Object.assign(this, {
			...json,
		});

		return this;
	}

	parseList(jsons: any) {
		if (!jsons || !jsons.length) return;

		return jsons.map((item: any) => new PaymentMethod().parse(item));
	}

	clone(): PaymentMethod {
		return new PaymentMethod({
			...this,
		});
	}
}
